export default __webpack_public_path__ + "static/media/banner-04.a790b00c.png";